
import { Income, IncomeExpense } from "../../classes"

const IncomeModule = {
  namespaced: true,
  state: {
    income: null
  },
  mutations: {
    setIncome(state, income) {
      state.income = income
    },
    clearIncome: (state) => {
      state.income = null
    },
  },
  actions: {
    getIncome: async ({ commit }, id) => {
      try{
        commit("clearIncome")
        const data = await Income.getIncome(id)
        commit("setIncome", data)
        commit("incomeExpense/updateIncomeExpense", IncomeExpense.generateByIncome(data), { root: true })
        return data
      }catch(error){
        throw error
      }
    },
    createIncome: async ({ dispatch }, formData) => {
      try {
        const data = await Income.createIncome(formData);
        await dispatch("getIncome", data.objectId)
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateIncome: async ({ dispatch }, formData) => {
      try {
        const data = await Income.updateIncome(formData);
        await dispatch("getIncome", data.objectId)
        return data;
      } catch (error) {
        throw error;
      }
    },
    removeIncome: async ({ commit }, id) => {
      try {
        const data = await Income.removeIncome(id);
        commit("incomeExpense/removeIncomeExpense", id, { root: true })
        return data;
      } catch (error) {
        throw error;
      }
    },
    getIncomeExpenseSummaryByMarket: async ({ commit }, formData) => {
      try {
        const data = await Income.getIncomeExpenseSummaryByMarket(formData)
        return data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    }
  },
  getters: {

  },
};
export default IncomeModule;
